export default __webpack_public_path__ + "static/media/char_body_prem_011.14a74ad9.png";